export enum DoseToAdministeredEnum {
  Frasco = 1,
  Ampola = 2,
  Ml = 3,
  Mg = 4,
  G = 5,
  Mcg = 6,
  Doses = 7,
  Aerossol = 8,
  Comprimido = 9,
  Capsula = 10
}